<template>
	<div class="instream-featured-module" v-if="displayModule" v-metric="{module: Omnituremodule}">	
	<header>
		<h3 v-if="QandAmodule">Suggested Questions</h3>
		<h3 v-else>Featured</h3>
	</header>	
		<ul>
			<li
				v-for="(item, index) in items"
				:key="item.title"
			>
			<div class="container">
				<div class="sponsortoppicks" v-if="item.sponsored"> Sponsored </div>
				<a
					v-metric="{link: index+1}"
					:href="item.href"
				>
					<span class="lnk-txt">{{ truncate(item.text, 65, '...')}}</span>
					<span class="right-arrow"><i class="webmd-icon-right-arrow"></i></span>				
				</a>
			</div>
			</li>
		</ul>

	</div>
</template>

<script>
import ModuleLinks from 'webmd-dynamic-links/index.es6';

export default {
	data() {
		return {
			items: [],
			Omnituremodule: 'lln-toppks',
			displayModule: true,
		};
	},

	components: {
		
	},

	props: {		
		FeaturedMmodule: {
			type: Boolean,
			default: false,	
		},

		QandAmodule: {
			type: Boolean,
			default: false,
		},
		margin: {
			type: Object,
			default() {
				return {
					top: 400,
					bottom: 100,
				};
			},
		},
	},
	computed: {
		
	},

	created() {
		if(this.QandAmodule) {
			this.Omnituremodule = 'qac-articledriver';
		}

	},
	
	mounted() {
		this.$nextTick(() => {
			// to lazy load
			const dlOptions = {
				module: this.QandAmodule ? 19: 17,
				count: 3
			};

			const self = this;
			const observer = new IntersectionObserver((entries) => {
				if (entries[0].isIntersecting) {
					ModuleLinks.fill(dlOptions).then((links) => {
						if (links) {	
							self.items = self.parseDynamicData(links);
							observer.unobserve(self.$el);
							if(self.items.length === 0) { 
								self.displayModule = false;
								if(entries[0] && entries[0].target && entries[0].target.parentNode) {
									if(entries[0].target.parentNode.className == 'instream-feature-module-container') {
										entries[0].target.parentNode.style.display='none';
									}									
								}								
							}
						} 
					});
				}
			},
			{ rootMargin: `${self.margin.bottom}px 0px ${self.margin.top}px 0px` });

			observer.observe(self.$el);

			// to refresh in the future outside of module
			document.addEventListener('webmd.wdl.refresh', async (event) => {
				if (!event.detail || event.detail === 19 || event.detail === 17) {
					const links = await ModuleLinks.fill(dlOptions);
					if (links) {
						self.items = self.parseDynamicData(links);
					}
				}
			});
		});
	}, 
	methods: {
		parseDynamicData(links) {
			return links.map((l) => ({
				text: l.title,
				href: l.url,
				sponsored: l.sponsored,
			}));
		},

		truncate(text, length, suffix) {
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        },

	},

};
</script>

<style lang="scss">
	@import "./stylesheets/variables";
	@import "./stylesheets/component.scss";
</style>


